<template>
	<!--<textarea
		ref="input"
		rows="2"
		class="bg-transparent outline-none"
		v-model="model"
	></textarea>-->
	<div>
		<el-input
		ref="input"
		type="textarea"
		autosize
		v-model="model">
		</el-input>
	</div>
	
</template>

<script>

	export default {

		name: 'Textarea',
		props: {
			placeholder: String,
			value: String,
			active: Boolean
		},
		data () {
			return {
				model: ''
			}
		},
		watch: {
			model (val) {

				this.$emit('input', val)

			},
			value (val) {
				this.model = val
			}
		},
		created () {
			
			this.model = this.value

		},
		methods: {
			focus () {

				this.$refs.input.focus()

			},
			next () {

				this.hover = this.hover + 1 > this.list.length - 1 ? 0 : this.hover + 1

			},
			back () {

				this.hover = this.hover - 1 < 0 ? this.list.length - 1 : this.hover - 1

			}
		}
	}
</script>

<style lang="scss">
</style>
